<template>
  <div class="page-cart">
    <CartRu v-if="product.region === 'ru'" />
    <!-- <Card v-if="$store.state.main.showPreload" /> -->
    <Cart v-else />
  </div>
</template>


<script>
import Cart from '../components/Cart'
import CartRu from '../components/CartRu'

export default {
  components: { Cart, CartRu },
  data () {
    return {
      isProcessing: false,
    }
  },
  computed: {
    product () {
      if (typeof this.$store.state.main.product !== 'undefined') {
        return this.$store.state.main.product
      } else {
        return {}
      }
    },
  },
  mounted () {
    if (window.yaCounter95625322) {
      if (this.$store.state.main.productId === 26578) {
        window.ym(95625322, 'reachGoal', 'open_basket', {
          order_price: this.$store.getters['cart/sum'],
          currency: 'RUB',
          cert_id: this.$store.state.cart.paymentCode,
        })
      }
    }

    if (window.yaCounter106237119) {
      if (this.$store.state.main.productId === 27732) {
        window.ym(106237119, 'reachGoal', 'open_basket', {
          order_price: this.$store.getters['cart/sum'],
          currency: 'RUB',
          cert_id: this.$store.state.cart.paymentCode,
        })
      }
    }

    if (window.yaCounter101503990) {
      if (this.$store.state.main.productId === 26285) {
        window.ym(101503990, 'reachGoal', 'open_basket', {
          order_price: this.$store.getters['cart/sum'],
          currency: 'RUB',
          cert_id: this.$store.state.cart.paymentCode,
        })
      }
    }

    if (window.yaCounter56585392) {
      if (this.$store.state.main.productId === 14103) {
        window.ym(56585392, 'reachGoal', 'open_basket', {
          order_price: this.$store.getters['cart/sum'],
          currency: 'RUB',
          cert_id: this.$store.state.cart.paymentCode,
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
